//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Performs submit action for data.
 * @param oldMbSerialNumber (optional) 
 * @param failureCategory (optional) The selected failure category from the predefined catalog.
 * @param otherCategoryDetails (optional) Free-text description provided when the "Other" category is selected.
Optional field for additional details.
 * @param requestFile (optional) 
 */
export function submit(oldMbSerialNumber?: string | undefined, failureCategory?: string | undefined, otherCategoryDetails?: string | null | undefined, requestFile?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StartReplacementOperationResponseDto> {
    let url_ = getBaseUrl() + "/api/mainboard-certificate?";
    if (oldMbSerialNumber === null)
        throw new Error("The parameter 'oldMbSerialNumber' cannot be null.");
    else if (oldMbSerialNumber !== undefined)
        url_ += "OldMbSerialNumber=" + encodeURIComponent("" + oldMbSerialNumber) + "&";
    if (failureCategory === null)
        throw new Error("The parameter 'failureCategory' cannot be null.");
    else if (failureCategory !== undefined)
        url_ += "FailureCategory=" + encodeURIComponent("" + failureCategory) + "&";
    if (otherCategoryDetails !== undefined && otherCategoryDetails !== null)
        url_ += "OtherCategoryDetails=" + encodeURIComponent("" + otherCategoryDetails) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (requestFile !== null && requestFile !== undefined)
        content_.append("requestFile", requestFile.data, requestFile.fileName ? requestFile.fileName : "requestFile");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSubmit,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSubmit?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSubmit(_response);
    });
}

function processSubmit(response: AxiosResponse): Promise<Types.StartReplacementOperationResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initStartReplacementOperationResponseDto(resultData200);
        return Promise.resolve<Types.StartReplacementOperationResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StartReplacementOperationResponseDto>(null as any);
}

/**
 * Gets result of PKI operation.
 */
export function getResult(operationId: number, config?: AxiosRequestConfig | undefined): Promise<Types.ReplacementResponseDto> {
    let url_ = getBaseUrl() + "/api/mainboard-certificate/result/{operationId}";
    if (operationId === undefined || operationId === null)
      throw new Error("The parameter 'operationId' must be defined.");
    url_ = url_.replace("{operationId}", encodeURIComponent("" + operationId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetResult,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetResult?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetResult(_response);
    });
}

function processGetResult(response: AxiosResponse): Promise<Types.ReplacementResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initReplacementResponseDto(resultData200);
        return Promise.resolve<Types.ReplacementResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ReplacementResponseDto>(null as any);
}

/**
 * An endpoint for downloading certificates.
 * @param fileName (optional) The certificate file name.
 */
export function download(fileName?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/mainboard-certificate/cert?";
    if (fileName === null)
        throw new Error("The parameter 'fileName' cannot be null.");
    else if (fileName !== undefined)
        url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDownload,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownload?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownload(_response);
    });
}

function processDownload(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get Test Data.
 */
export function getTestData(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/mainboard-certificate/cert/get-test-data";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetTestData,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetTestData?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetTestData(_response);
    });
}

function processGetTestData(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigSubmit: Partial<AxiosRequestConfig> | null;
export function getSubmitRequestConfig() {
  return _requestConfigSubmit;
}
export function setSubmitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSubmit = value;
}
export function patchSubmitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSubmit = patch(_requestConfigSubmit ?? {});
}

let _requestConfigGetResult: Partial<AxiosRequestConfig> | null;
export function getGetResultRequestConfig() {
  return _requestConfigGetResult;
}
export function setGetResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetResult = value;
}
export function patchGetResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetResult = patch(_requestConfigGetResult ?? {});
}

let _requestConfigDownload: Partial<AxiosRequestConfig> | null;
export function getDownloadRequestConfig() {
  return _requestConfigDownload;
}
export function setDownloadRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownload = value;
}
export function patchDownloadRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownload = patch(_requestConfigDownload ?? {});
}

let _requestConfigGetTestData: Partial<AxiosRequestConfig> | null;
export function getGetTestDataRequestConfig() {
  return _requestConfigGetTestData;
}
export function setGetTestDataRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetTestData = value;
}
export function patchGetTestDataRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetTestData = patch(_requestConfigGetTestData ?? {});
}